export default __webpack_public_path__ + "static/media/Bullmight Band.4a4ebc9c.jpg";